// @generated by protoc-gen-es v1.2.0 with parameter "target=js+dts"
// @generated from file wavin/aqora/v2/reservoir_dynamic_info.proto (package wavin.aqora.v2, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import {proto3, Timestamp} from "@bufbuild/protobuf";
import {Metric} from "./metrics_pb.js";

/**
 * @generated from message wavin.aqora.v2.GetDynamicReservoirInfoRequest
 */
export const GetDynamicReservoirInfoRequest = proto3.makeMessageType(
  "wavin.aqora.v2.GetDynamicReservoirInfoRequest",
  () => [
    {no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */},
    {no: 2, name: "before_time", kind: "message", T: Timestamp},
  ],
);

/**
 * @generated from message wavin.aqora.v2.DynamicReservoirInfo
 */
export const DynamicReservoirInfo = proto3.makeMessageType(
  "wavin.aqora.v2.DynamicReservoirInfo",
  () => [
    {no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */},
    {no: 100, name: "predicted_time", kind: "message", T: Timestamp},
    {no: 2, name: "predicted_water_height", kind: "message", T: Metric},
    {no: 3, name: "rule_water_height", kind: "message", T: Metric},
    {no: 4, name: "forecast_temperature", kind: "message", T: Metric},
    {no: 5, name: "forecast_precipitation", kind: "message", T: Metric},
    {no: 6, name: "receiving_other_reservoirs", kind: "message", T: Metric},
    {no: 7, name: "receiving_tap", kind: "message", T: Metric},
    {no: 8, name: "dumping_other_reservoirs", kind: "message", T: Metric},
    {no: 9, name: "dumping_sewer", kind: "message", T: Metric},
  ],
);

